<h2 mat-dialog-title class="text-lg font-bold mb-1">Detalle</h2>
<mat-dialog-content class="modal-content">
  <ngx-json-viewer [json]="this.data" [expanded]="false"></ngx-json-viewer>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="onSubmit()"class="justify-end">Aceptar</button>
</mat-dialog-actions>  